
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import '../../../../node_modules/core-js/modules/es.array.concat.js';
import '../../../../node_modules/core-js/modules/es.array.find.js';
import '../../../../node_modules/core-js/modules/es.array.map.js';
import '../../../../node_modules/core-js/modules/es.object.to-string.js';
import React__default, { memo } from 'react';
import Cell from './Cell.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var DataCells = function DataCells(_ref) {
  var accessors = _ref.accessors,
    row = _ref.row,
    columns = _ref.columns,
    windowWidth = _ref.windowWidth,
    windowHeight = _ref.windowHeight,
    handleRowClick = _ref.handleRowClick;
  return jsx(React__default.Fragment, null, accessors.map(function (accessor) {
    var _columns$find;
    var rowObj = row[accessor];
    var _ref2 = (_columns$find = columns.find(function (column) {
        return column.accessor === accessor;
      })) !== null && _columns$find !== void 0 ? _columns$find : {},
      maxWidth = _ref2.maxWidth;
    var cellId = "entry-".concat(row.id, "-").concat(accessor);
    return jsx(Cell, {
      key: cellId,
      id: cellId,
      "data-testid": "".concat(accessor, "-cell"),
      maxWidth: maxWidth,
      windowWidth: windowWidth,
      windowHeight: windowHeight,
      onClick: handleRowClick
    }, typeof rowObj === "function" ? rowObj(row) : rowObj);
  }));
};
var DataCells$1 = /*#__PURE__*/memo(DataCells);

export { DataCells$1 as default };
//# sourceMappingURL=DataCells.js.map
